import { createAction, props } from '@ngrx/store';
import { TrendPoint } from '../../models/trend-chart.model';

export const loadTrendIfNeeded = createAction(
  '[RuleResult] Load Trend If Needed',
  props<{
    uid: string;
    range: string;
    alertThreshold?: number;
    interpolationInMinutes: number;
  }>(),
);

export const loadTrend = createAction(
  '[RuleResult] Load Trend',
  props<{
    uid: string;
    range: string;
    alertThreshold?: number;
    interpolationInMinutes: number;
  }>(),
);

export const loadTrendSuccess = createAction(
  '[RuleResult] Load Trend Success',
  props<{
    uid: string;
    range: string;
    rawData: TrendPoint[];
    fetchedAt: number;
  }>(),
);

export const loadTrendFailure = createAction(
  '[RuleResult] Load Trend Failure',
  props<{ uid: string; range: string; error: string }>(),
);

export const loadHealthIndicatorTrendIfNeeded = createAction(
  '[RuleResult] Load Health Indicator Trend If Needed',
  props<{
    uid: string;
    range: string;
    alertThreshold?: number;
    interpolationInMinutes: number;
  }>(),
);

export const loadHealthIndicatorTrend = createAction(
  '[RuleResult] Load Health Indicator Trend',
  props<{
    uid: string;
    range: string;
    alertThreshold?: number;
    interpolationInMinutes: number;
  }>(),
);

export const loadHealthIndicatorTrendSuccess = createAction(
  '[RuleResult] Load Health Indicator Trend Success',
  props<{
    uid: string;
    range: string;
    rawData: TrendPoint[];
    fetchedAt: number;
  }>(),
);

export const loadHealthIndicatorTrendFailure = createAction(
  '[RuleResult] Load Health Indicator Trend Failure',
  props<{ uid: string; range: string; error: string }>(),
);

export const loadAlarmDetailsTrendIfNeeded = createAction(
  '[RuleResult] Load Alarm Details Trend If Needed',
  props<{
    uid: string;
    range: string;
    alertThreshold?: number;
    interpolationInMinutes: number;
  }>(),
);

export const loadAlarmDetailsTrend = createAction(
  '[RuleResult] Load Alarm Details Trend',
  props<{
    uid: string;
    range: string;
    alertThreshold?: number;
    interpolationInMinutes: number;
  }>(),
);

export const loadAlarmDetailsTrendSuccess = createAction(
  '[RuleResult] Load Alarm Details Trend Success',
  props<{
    uid: string;
    range: string;
    rawData: TrendPoint[];
    fetchedAt: number;
  }>(),
);

export const loadAlarmDetailsTrendFailure = createAction(
  '[RuleResult] Load Alarm Details Trend Failure',
  props<{ uid: string; range: string; error: string }>(),
);
